import React from "react";
import { useLaunchParams } from "@telegram-apps/sdk-react";
import { DesktopLayout } from "@/layouts/DesktopLayout";
import { ExchangeConnectList } from "@/components/ExchangeConnectList";
import { AutotradeTriggerManager } from "@/components/AutotradeTriggerManager";

export const SettingsPageDesktop: React.FC = () => {
  const launchParams = useLaunchParams();
  const userId = launchParams.initData?.user?.id?.toString() || "";

  return (
    <DesktopLayout
      pageTitle="Settings"
      pageDescription="Manage your exchange connections and autotrade settings"
      showRightSidebar={false}
    >
      <div className="max-w-4xl mx-auto space-y-6 min-h-[100vh]">
        <ExchangeConnectList userId={userId} />
        <AutotradeTriggerManager userId={userId} />
      </div>
    </DesktopLayout>
  );
};
